import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Step, StepLabel, Theme } from "@material-ui/core";
import StepTopLabel from "./StepTopLabel";
import ICalloutRequestedStep from "./types/ICalloutRequestedStep";

import StepIcon from "./StepIcon";
import { etaStepId } from "./calloutRequestedData";

interface CalloutRequestedStepProps {
  step: ICalloutRequestedStep;
  activeStepId: number;
  isCalloutFinished: boolean;
  eta: string;
}

export interface StyleProps {
  isCalloutFinished: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(() => ({
  labelBlock: {
    color: "white",
    fontSize: 26,
    fontWeight: 700,
    fontFamily: "lato",
    lineHeight: "normal",
    marginTop: -19,
    opacity: (props) => (props.isCalloutFinished ? "0.7" : ""),
  },
  etaBlock: {
    backgroundColor: "#3FA052",
    height: 29,
    // width: 103,
    paddingLeft: 4,
    paddingRight: 4,
    color: "#00152E",
    fontSize: 18,
    fontWeight: 700,
    fontFamily: "lato",
    borderRadius: 4,
    display: "inline-grid",
    marginTop: 10,
    alignItems: "center",
  },
}));

const isCompleted = (stepId: number, activeStepId: number): boolean => stepId < activeStepId;
const isActive = (stepId: number, activeStepId: number): boolean => stepId === activeStepId;

const CalloutRequestedStep: React.FC<CalloutRequestedStepProps> = (props) => {
  const { step, activeStepId, isCalloutFinished, eta, ...other } = props;
  const classes = useStyles({ isCalloutFinished });
  return (
    <Step completed={isCompleted(step.id, activeStepId)} active={isActive(step.id, activeStepId)} {...other}>
      <StepTopLabel step={step} />
      <StepLabel StepIconComponent={() => <StepIcon step={step} activeStepId={activeStepId} isCallouFinished={isCalloutFinished} />}>
        <div className={classes.labelBlock}>
          <div>{step.name1}</div>
          <div>{step.name2 ?? ""}</div>
        </div>
        {etaStepId === step.id && isActive(step.id, activeStepId) && (
          <div className={classes.etaBlock}>{!eta ? "Calculating ETA..." : `ETA ${eta}`}</div>
        )}
      </StepLabel>
    </Step>
  );
};

export default CalloutRequestedStep;
